import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment, TextField } from "@mui/material";
import { useMemo, useState } from "react";
import { KNOWLEDGE_BASE_DATA } from "./knowledgeBaseData";

const KnowledgeBaseSearch = ({ onSelectArticle }) => {
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const searchResults = useMemo(() => {
    if (!query.trim()) return [];
    const q = query.toLowerCase().trim();
    const results = [];

    KNOWLEDGE_BASE_DATA.forEach((moduleItem) => {
      moduleItem.topics.forEach((topic) => {
        topic.groups.forEach((group) => {
          group.items.forEach((item) => {
            const matchTitle = item.title?.toLowerCase().includes(q);
            const matchSummary = item.summary?.toLowerCase().includes(q);
            const matchWorkflow = item.workflow?.toLowerCase().includes(q);

            if (matchTitle || matchSummary || matchWorkflow) {
              results.push({
                item,
                groupTitle: group.title,
                topicTitle: topic.title,
                moduleTitle: moduleItem.title,
              });
            }
          });
        });
      });
    });

    return results;
  }, [query]);

  const handleSelect = (result) => {
    onSelectArticle(result.item.id);
    setQuery("");
    setIsOpen(false);
  };

  return (
    <div className="kb-search-box-wrapper">
      <TextField
        fullWidth
        placeholder="Search topics, workflows, or fields (e.g. Add procedure, Prescriptions, Administer...)"
        value={query}
        onChange={(e) => {
          setQuery(e.target.value);
          setIsOpen(true);
        }}
        onFocus={() => setIsOpen(true)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: "#0054A6" }} />
            </InputAdornment>
          ),
          sx: {
            backgroundColor: "#FFFFFF",
            borderRadius: "30px",
            fontSize: "15px",
            boxShadow: "0 4px 14px rgba(0, 0, 0, 0.1)",
            "& fieldset": { border: "none" },
            px: 1,
          },
        }}
      />

      {isOpen && query.trim().length > 0 && (
        <div className="kb-search-results-dropdown">
          {searchResults.length > 0 ? (
            searchResults.map((res, index) => (
              <div
                key={index}
                className="kb-search-item"
                onClick={() => handleSelect(res)}
              >
                <div className="kb-search-item-breadcrumb">
                  {res.moduleTitle} &gt; {res.topicTitle} &gt; {res.groupTitle}
                </div>
                <div className="kb-search-item-title">{res.item.title}</div>
                {res.item.summary && (
                  <div className="kb-search-item-summary">
                    {res.item.summary}
                  </div>
                )}
              </div>
            ))
          ) : (
            <div className="kb-search-item" style={{ color: "#64748B" }}>
              No results found for "{query}"
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default KnowledgeBaseSearch;
